exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".material[data-v-63a8fb67]{margin-top:40px}.ext-bar-label[data-v-63a8fb67],.more-btn[data-v-63a8fb67]{font-size:14px}.more-btn[data-v-63a8fb67]{display:block;width:143px;height:35px;line-height:33px;margin:10px auto;background:#fff;text-align:center;border:1px solid #0095ff;border-color:#0095ff;color:#0095ff;border-radius:2px;-webkit-transition:all .3s;transition:all .3s}.more-btn[data-v-63a8fb67]:hover{background:#0095ff;color:#fff}", ""]);

// exports
